// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32kh-","add":"styles_add__e_OnA","remove":"styles_remove__31Vn_"};